import { formatDate } from "@ui-seeker/utils"


export default function firstDateColumn() {
    return {
        name: "firstDate", label: "First Date",
        options: {
            filter: false,
            customBodyRowRender: value => value ? formatDate(value, { isString: true }) : "--",
        }
    }
}